/**
 * Mounts the idle-session driver for the signed-in user and renders its
 * dialog. One instance per app (App.jsx).
 */
import { useSelector } from 'react-redux';
import { useIdleSession } from '../model/useIdleSession';
import IdleDialog from './IdleDialog';

const SessionIdle = () => {
  const isLogin = useSelector(state => state.user.isLogin);
  const dialogOpen = useSelector(state => state.appSettings.isAutoLogoutDialogOpen);
  const { remainingMs, stay, logOut } = useIdleSession({ enabled: !!isLogin });

  return (
    <IdleDialog
      open={dialogOpen && !!isLogin}
      seconds={Math.max(0, Math.ceil((remainingMs ?? 0) / 1000))}
      onStay={stay}
      onLogout={logOut}
    />
  );
};

export default SessionIdle;
